/**
 * Global Cart Service
 * Holds the current state of the cart
 * handles updating quantity and removing items
 **/

import { eventBus } from './';

const CartService = function () {
  let $this = {};

  $this.currentProduct = false;
  $this.productAdded = false;

  $this.init = function () {
    $this.getCart();
    eventBus.on(eventBus.types.AddingToCart, $this.AddingToCart);
    eventBus.on(eventBus.types.AddedToCart, $this.addedToCart);
  };
  $this.AddingToCart = function ($data) {
    $this.currentProduct = $data.detail;
  };

  $this.addedToCart = function ($data) {
    $this.productAdded = $data;
    $this.getCart();
  };

  $this.getCart = function () {
    fetch('/cart.json').then((res) => {
      res.json().then((json) => {
        $this.cart = json;
        eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
      });
    });
  };

  /**
   * Remove a single item based on the key
   * @param {*} key
   * @returns
   */
  $this.removeItem = function (key) {
    const $promise = new Promise(function (resolve, reject) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 0, id: key }),
      }).then((res) => {
        res.json().then((json) => {
          $this.cart = json;
          resolve({ cart: $this.cart, success: true });
          eventBus.dispatch(eventBus.RemovedFromCart, {
            cart: $this.cart,
            key: key,
          });
          eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
        });
      });
    });
    return $promise;
  };

  /**
   * Remove multiple items from cart
   * simply passes the keys into the updat4eQuantity__update function
   */
  $this.removeItems = async (keys) => {
    let updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });
    return $this.updateQuantity__update(updates);
  };

  /**
   * Update the quantity of a specific cart item
   * @param {*} key
   * @param {*} value
   * @param {*} line
   * @returns
   */
  $this.updateQuantity = function (key, value) {
    const $promise = new Promise(function (resolve, reject) {
      const data = { quantity: value, id: key };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then((response) => {
          response.json().then((json) => {
            $this.cart = json;
            resolve({ cart: $this.cart, success: true });
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
          });
        })
        .catch((error) => {
          alert('There was an error updating the quantity ');
          reject();
        });
    });
    return $promise;
  };

  /**
   * Update the quantities of mutliple cart items based on key
   * Updates { key : quantity, key : quantity }
   * @param {*} updates
   * @returns
   */
  $this.updateQuantity__update = function (updates) {
    const $promise = new Promise(function (resolve, reject) {
      const data = { updates: updates };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then((response) => {
          response.json().then((json) => {
            $this.cart = json;
            resolve({ cart: $this.cart, success: true });
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
          });
        })
        .catch((error) => {
          alert('There was an error updating the quantity ');
          reject();
        });
    });
    return $promise;
  };

  /**
   * Find an item in the current cart by the uid property
   * Return false if not found
   * @param {*} uid
   * @returns cartItem
   */
  $this.getCartItemByUID = function (uid) {
    if (!$this.cart || !$this.cart.items) {
      return false;
    }

    item = $this.cart.items.find((item) => item.properties._uid === uid);
    if (item) {
      return item;
    } else {
      console.log(uid + ' not found in cart');
      return false;
    }
  };

  return $this;
};

export default CartService;
